module.exports = __webpack_public_path__ + "images/branding/savemyhomeusa/left_tab.gif";